import { PAGES } from "@consts";
import { getLettersQueryParam } from "@utils";
import noIndexExceptions from "./noindex-exceptions.json";

export const calculateRangeForPagination = (page, itemsPerPage, totalItems) => {
	let start = 1;
	const end = Math.min(itemsPerPage * page, totalItems);

	if (page > 1) {
		start += itemsPerPage * page - itemsPerPage;
	}

	return {
		start,
		end,
	};
};

export const generatePaginationShownWordsText = (start, end, total) => {
	if (end >= total) {
		if (start === 1) {
			return `${total}`;
		}

		return `${start}-${total}`;
	}

	return `${start}-${end}`;
};

export const generateShowMoreShownWordsText = (itemsToShow, total) =>
	itemsToShow <= total ? `${itemsToShow}` : `${total}`;

export const shouldSetWordListNoIndexHeader = ({
	route,
	totalResultsCount,
}) => {
	// We directly set noindex the page if it has no results
	if (totalResultsCount < 1) {
		return true;
	}

	// We directly set noindex for words that are not between 3 and 15 letters long
	const lengthVal = route.params.length || parseInt(route.params.advanced);
	// Yes, yes, we could combine this conditional, but this is for better readability
	if (lengthVal && !isNaN(lengthVal)) {
		if (lengthVal < 2 || lengthVal > 15) {
			return true;
		}
	}

	// If ANY of the advanced fields has more than 3 letters AND is not an exception, we noindex it directly
	const mustNoIndex = (key) => {
		const value =
			route.params.letter ||
			getLettersQueryParam(route.params.advanced, key);

		const exceptions = noIndexExceptions[key];

		return value.length > 3 && !exceptions.includes(value);
	};

	if (route.name === PAGES.WORDS_STARTING_RESULTS) {
		if (mustNoIndex("starts")) {
			return true;
		}
	} else if (route.name === PAGES.WORDS_ENDING_RESULTS) {
		if (mustNoIndex("ends")) {
			return true;
		}
	} else if (route.name === PAGES.WORDS_HAVING_RESULTS) {
		if (mustNoIndex("with")) {
			return true;
		}
	} else if (
		route.name === PAGES.WORDS_COMBINATION_LETTERS_RESULTS ||
		route.name === PAGES.WORDS_COMBINATION_LENGTH_AND_LETTERS_RESULTS
	) {
		for (const key of ["starts", "with", "ends"]) {
			if (mustNoIndex(key)) {
				return true;
			}
		}
	}

	return false;
};

export const shouldSetScrabbleNoIndexHeader = ({
	route,
	totalResultsCount,
}) => {
	const exceptions = noIndexExceptions.scrabble;
	if (exceptions.includes((route.params.tiles || "").toLowerCase())) {
		return false;
	}

	return true;
};

/**
 * @param {import('vue-router/types').Route} route
 * @param {number} totalResultsCount
 * @returns {boolean}
 */
export const shouldSetNoIndexHeader = ({ route, totalResultsCount }) => {
	if (
		[
			PAGES.WORDS_COMBINATION_LETTERS_RESULTS,
			PAGES.WORDS_COMBINATION_LENGTH_AND_LETTERS_RESULTS,
			PAGES.WORDS_STARTING_RESULTS,
			PAGES.WORDS_ENDING_RESULTS,
			PAGES.WORDS_HAVING_RESULTS,
			PAGES.WORDS_BY_LENGTH_RESULTS,
		].includes(route.name)
	) {
		return shouldSetWordListNoIndexHeader({ route, totalResultsCount });
	}

	if (route.name === PAGES.SCRABBLE_DICT_RESULTS) {
		return shouldSetScrabbleNoIndexHeader({ route, totalResultsCount });
	}

	if (route.name === PAGES.NYT_CROSSPLAY_DICTIONARY_RESULTS) {
		return true;
	}
	/**
	 * @note: unscramble noindexing is still handled by the `cf_filter_wfw` terraform function.
	 * Once it is moved here, please remember to remove that functionality.
	 */

	return false;
};
